import React from 'react'
import PropTypes from 'prop-types'
import { ScreenSelector } from 'components/molecules'
import { Modal } from 'components/organisms'
import * as S from './styled'

const View = ({
  tapToControl,
  isScreenSelectorOpened,
  onClose,
  isModalDisabled,
  screens,
  handleScreenChange,
  screenSelected,
}) => (
  <S.MasterContainer>
    <S.TouchToControlContainer onClick={tapToControl} className='heartbeat-animation'>
      <span>Tap here to start</span>
    </S.TouchToControlContainer>
    <S.Footer />

    <Modal isOpened={isScreenSelectorOpened} onClose={onClose} disabled={isModalDisabled}>
      <ScreenSelector
        screens={screens}
        handleChange={value => handleScreenChange(value)}
        screenSelected={screenSelected}
      />
    </Modal>
  </S.MasterContainer>
)

View.defaultProps = {
  screens: [],
  screenSelected: {},
}

View.propTypes = {
  tapToControl: PropTypes.func.isRequired,
  isScreenSelectorOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isModalDisabled: PropTypes.bool.isRequired,
  screens: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  handleScreenChange: PropTypes.func.isRequired,
  screenSelected: PropTypes.object,
}

export default View
